import { AxiosPromise } from "axios";
import axios from "../../../../utils/axios";

type BulkImportRequest = {
  csvImportId: string;
  orgId: string;
};

export async function importUsers(
  request: BulkImportRequest
): Promise<AxiosPromise> {
  return await axios.post(`accreditations/users/v1/import-from-csv`, request);
}
